import loadingReducer from "../connected-components/loader/reducer";
import themeReducer from "../theme/reducer";
import authReducer from "../screens/auth/login/reducer";
import modalReducer from "../connected-components/modal/reducer";
import qaReducer from "../screens/content/qa/reducer";
import billingReducer from "../screens/content/billing/reducer";
import currenciesReducer from "../screens/content/settings/currencies/reducer";
import insurersReducer from "../screens/content/settings/insurers/reducer";
import patientsReducer from "../screens/content/patients/list/reducer";
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  loading: loadingReducer,
  theme: themeReducer,
  auth: authReducer,
  modal: modalReducer,
  qa: qaReducer,
  billing: billingReducer,
  currencies: currenciesReducer,
  insurers: insurersReducer,
  patients: patientsReducer,
};
